import React from 'react';
import { TextFeature } from '../types';
import AppFeatures from '../components/Views/AppFeatures';
import WorkHistory from '../components/Views/WorkHistory';
import Contact from '../components/Views/Contact';
import Hero from '../components/Views/Hero';
import MyStory from '../components/Views/MyStory';

const textFeatures: TextFeature[] = [
  {
    id: 'work-history',
    title: 'Work History',
    content: '' // Content is now handled by the WorkHistory component
  },
  {
    id: 'contact',
    title: 'Contact',
    content: '' // Content is now handled by the Contact component
  },
];

interface HomeProps {
  isKindred?: boolean;
}

const heroSubtitle = "Co-Founder. Product Manager. Engineer.";
const aboutText =
  "I'm a product manager by trade. Then in 2019, I had an idea for a side project. " +
  "An iPhone app. So I taught myself to code. Built the app. " +
  "Launched it in the App Store. Half Lemons was born. \n\n And it took off.\n\n" +
  "The app was picked up on Reddit. Then TechCrunch. Recognized by Apple. Featured in the App Store. " +
  "I was learning to code one day. Shipping features the next. Designing mockups. Emailing with journalists & customers. " +
  "And loving it. \n\n" +
  "I grew my side project into a profitable business. That's how I found my calling. I love " +
  "bringing surprise & delight into the world. Code is one tool for that. Product roadmaps are " +
  "another. Great marketing. Pricing. Happy customers." +
   "\n\n I'm here for all of it.";

const Home: React.FC<HomeProps> = ({ isKindred }) => {

  return (
    <div className="min-h-screen mt-2 sm:mt-12 bg-white text-black">
      {/* Content Column */}
      <div className="w-full max-w-[55rem] py-8 px-4 mx-auto">
        {/* Hero Section with Image */}
        <section className="mb-16">
          <Hero heroSubtitle={heroSubtitle} isKindred={isKindred} />
          <MyStory aboutText={aboutText} />
        </section>

        {/* Featured Section */}
        <section className="mb-16">
          <div className="space-y-12">
            {/* Apps I've Built */}
            <AppFeatures />

            {/* Text Features */}
            {textFeatures.map((feature) => (
              <div key={feature.id}>
                <h3 className="text-lg font-light text-black mb-4">{feature.title}</h3>
                <div className={`rounded-lg ${feature.id === 'work-history' ? 'pl-0 pr-0' : 'pl-4 sm:pl-0'}`}>
                  {feature.id === 'work-history' ? (
                    <WorkHistory />
                  ) : feature.id === 'contact' ? (
                    <Contact />
                  ) : (
                    <p className="text-black text-left">
                      {feature.content}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;